import PrivacyPolicy from './PrivacyPolicy';
export default PrivacyPolicy; 